// @flow

import * as React from 'react';
import { history } from '@insolus/react-router';
import Config from '@insolus/config';

import type { Store } from '@insolus/stores';

export type AlertObject = {|
    type: 'success' | 'error' | 'info' | 'warning',
    title?: string,
    message: string | string[] | React.Node
|};

export type AlertStrict = AlertObject | null;

class UiStore implements Store {
    alert: AlertStrict = null;
    isStatic: boolean = false;

    init() {
        this.alert = Config.get('serverContext.alert', null);
        this.isStatic = Config.get('serverContext.rendering') === 'static';
    }

    // ------------------------------------------------------
    // -
    // -    Actions
    // -
    // ------------------------------------------------------

    useAlert(): AlertStrict {
        const _alert = this.alert ? { ...this.alert } : null;
        this.alert = null;
        return _alert;
    }

    setAlert(alert: AlertObject, route: string = '/') {
        this.alert = { ...alert };
        history.replace(route);
    }
}

export default (new UiStore(): UiStore);
export { UiStore };
